import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';

const MobileBottomNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useLanguage();

  const navItems = [
    { path: '/', icon: '📋', label: t('tasks') },
    { path: '/calendar', icon: '📅', label: t('calendar') },
    { path: '/contacts', icon: '👥', label: t('contacts') },
    { path: '/settings', icon: '⚙️', label: t('settings') }
  ];

  return (
    <div className="mobile-bottom-nav footer fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50">
      <div className="flex justify-around items-center py-2">
        {navItems.map((item) => (
          <button
            key={item.path}
            onClick={() => navigate(item.path)}
            className={`mobile-nav-item flex flex-col items-center p-2 rounded-lg transition-all ${
              location.pathname === item.path 
                ? 'bg-gradient-to-r from-blue-500 to-indigo-600 text-white' 
                : 'text-gray-600 hover:bg-gray-100'
            }`}
          >
            <span className="text-xl mb-1">{item.icon}</span>
            <span className="text-xs font-medium">{item.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default MobileBottomNav;